export default function setShowRefAction(selectedReferenceData) {
    return {
        type: 'SET_SELECTED_REFERENCE_DATA',
        payload: selectedReferenceData
    }
}